<template>
  <div>
    This is chats
  </div>
</template>

<script>
export default {
  name: 'ChatsPage'
}
</script>

<style lang="scss" scoped>

</style>